import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAdminAuth } from "@/contexts/AdminAuthContext";

export default function AdminLogin() {
  const { isAuthenticated, login, loading } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (loading) return null;
  if (isAuthenticated) return <Navigate to="/atelier-admin/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email.trim(), password);
      toast.success("Welcome, Atelier.");
      navigate("/atelier-admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-midnight-deep flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md border border-white/10 bg-midnight p-8 md:p-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 border border-silver/60 flex items-center justify-center">
            <Lock size={16} strokeWidth={1.2} className="text-silver" />
          </div>
          <div>
            <div className="eyebrow text-silver/70">Atelier</div>
            <div className="font-serif text-white text-2xl">Admin Access</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="space-y-6">
          <div>
            <label className="text-[10px] tracking-[0.35em] uppercase text-silver/70">Email</label>
            <input
              data-testid="admin-login-email"
              type="email"
              autoFocus
              required
              className="lux-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <label className="text-[10px] tracking-[0.35em] uppercase text-silver/70">Password</label>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              className="lux-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="w-full bg-white text-black py-3.5 uppercase tracking-[0.32em] text-[11px] hover:bg-silver disabled:opacity-50"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="mt-8 text-[10px] tracking-[0.25em] uppercase text-white/40 text-center">
          Restricted. Authorized atelier personnel only.
        </p>
      </div>
    </div>
  );
}
